import { sleep } from "utils/promise-functions";

export const createDraftListing = async () => {
  await sleep();
  return {
    id: "12345",
  };
};
